<mat-card class="order-details-container">  
  <div class="additional-info-panel">      
      <div class="save-as-dialog-title">
        <div class="additional-info-panel-header">Additional Partner Information</div>
        <button mat-icon-button class="additional-info-close-btn" (click)="handleClick('eventEmitter')" >
          <mat-icon>clear</mat-icon>
        </button>
      </div>
      <div class="additionalInfo-textarea"><textarea class="partner-info" matInput [value]="additionalPartnerInfo"
          readonly="true"></textarea>
      </div>
  </div>  
</mat-card>